export default __webpack_public_path__ + "static/img/no.63245853.png";